import lgL from "./light/fashionify_light@lg.jpg";
import mdL from "./light/fashionify_light@md.jpg";
import smL from "./light/fashionify_light@sm.jpg";
import lgD from "./dark/fashionify_dark@lg.jpg";
import mdD from "./dark/fashionify_dark@md.jpg";
import smD from "./dark/fashionify_dark@sm.jpg";

const fashionify = {
  light: [lgL, mdL, smL],
  dark: [lgD, mdD, smD],
};

export default fashionify;
